import { render, staticRenderFns } from "./ColorIndicator.vue?vue&type=template&id=62a597b5&scoped=true&lang=pug&"
import script from "./ColorIndicator.vue?vue&type=script&lang=js&"
export * from "./ColorIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ColorIndicator.vue?vue&type=style&index=0&id=62a597b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a597b5",
  null
  
)

export default component.exports